const locationHelpers = {};

locationHelpers.buildLocationDropDown = (locations, selectAll = false) => {
  return locations.map((loc) => {
    return {
      value: selectAll,
      name: loc.name,
      placeholder: loc.name
    }
  })
}

locationHelpers.updateLocationDropDown = (locations, id, value) => {
  return locations.map((loc, index) => {
    if (index === id) {
      return {
        value: value,
        name: loc.name,
        placeholder: loc.name
      }
    } else {
      return {
        value: false,
        name: loc.name,
        placeholder: loc.name
      }
    }
  })
}

export default locationHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/locations/select.js
 **/